<template>
    <div>
        <el-row class="p-4 text-center" v-if="user && user.is_fullaccess">
            <a href="/dashboard">
                <el-button type="info" size="large" round>Sales</el-button>
            </a>
            <a class="ml-2" href="/dashboard?type=operation">
                <el-button type="info" size="large" round>Operation</el-button>
            </a>
            <a class="ml-2" href="/dashboard?type=account">
                <el-button type="info" size="large" round>Account</el-button>
            </a>
            <a class="ml-2" href="/dashboard?type=qc">
                <el-button type="info" size="large" round>QC</el-button>
            </a>
        </el-row>

        <el-row class="pt-2" justify="end" :gutter="20">
            <el-col :span="3">
                <el-select @change="getdata" v-model="form.type">
                    <el-option :value="0" label="Default" />
                    <el-option :value="1" label="Enquiry date" />
                </el-select>
            </el-col>
            <el-col :span="6">
                <el-date-picker
                    @change="getdata"
                    v-model="form.date"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    format="DD MMM YYYY"
                    value-format="YYYY-MM-DD"
                />
            </el-col>
        </el-row>

        <el-row class="ml-4 mr-4 mt-2" v-if="reports != null" :gutter="16">
            <el-col :span="3">
                <div class="statistic-card">
                    <el-statistic :value="reports.dayleads">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Day Leads
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="3">
                <div class="statistic-card">
                    <el-statistic :value="reports.working">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Working Leads
                                <el-tooltip
                                    effect="dark"
                                    :content="'Pending - ' + reports.pending + ' Inprogress - ' + reports.inprogress"
                                    placement="top"
                                >
                                    <el-icon style="margin-left: 4px" :size="12">
                                        <Warning />
                                    </el-icon>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="3">
                <div class="statistic-card">
                    <el-statistic :value="reports.called">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Called Leads
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="3">
                <div class="statistic-card">
                    <el-statistic :value="reports.closed">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Closed Leads
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="3">
                <div class="statistic-card">
                    <el-statistic :value="reports.quotes">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Quotations Sent
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="3">
                <div class="statistic-card">
                    <el-statistic :value="reports.converted">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Bookings
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="3">
                <div class="statistic-card">
                    <el-statistic :value="reports.profit">
                        <template #title>
                            <div style="display: inline-flex; align-items: center">
                                Profit
                            </div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>

            <el-col :span="3">
                <div class="statistic-card" style="padding: 0px">
                    <vue-apex-charts
                        type="radialBar"
                        :options="chartOptions"
                        :series="[percentComplete()]"
                        height="150"
                    />
                </div>
            </el-col>
        </el-row>

        <el-row class="m-4" v-if="reports != null">
            <el-table
                v-if="reports.list.length > 0"
                :data="reports.list"
                style="width: 100%; margin-bottom: 20px"
                row-key="name"
                border
                :tree-props="{ children: 'list' }"
            >
                <el-table-column prop="name" label="Name" width="200" />
                <el-table-column prop="dayleads" label="Day Leads" />
                <el-table-column prop="working" label="Working Leads" />
                <el-table-column prop="pending" label="Pending" />
                <el-table-column prop="inprogress" label="Inprogress" />
                <el-table-column prop="called" label="Called Leads" />
                <el-table-column prop="closed" label="Closed" />
                <el-table-column prop="quotes" label="Quotes" />
                <el-table-column prop="converted" label="Converted" />
                <el-table-column prop="profit" label="Profit" />
                <el-table-column prop="target" label="Target" :width="200">
                    <template #default="scope">
                        {{ scope.row.target }}
                        <el-tag type="success" class="ml-2" v-if="getPercentage(scope.row.profit, scope.row.target) >= 100">
                            {{ getPercentage(scope.row.profit, scope.row.target) }}%
                        </el-tag>
                        <el-tag type="warning" class="ml-2" v-else-if="getPercentage(scope.row.profit, scope.row.target) >= 50">
                            {{ getPercentage(scope.row.profit, scope.row.target) }}%
                        </el-tag>
                        <el-tag type="danger" class="ml-2" v-else>
                            {{ getPercentage(scope.row.profit, scope.row.target) }}%
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row class="m-4" v-if="reports != null">
            <el-col :span="24">
                <vue-apex-charts
                    type="line"
                    height="350"
                    :options="leadsstatusCO"
                    :series="reports.graph.leads.report"
                ></vue-apex-charts>
            </el-col>
        </el-row>

    </div>
</template>

<script>
import {
    ElRow, ElButton, ElDatePicker, ElCol, ElTableColumn, ElTable,
    ElStatistic, ElTooltip, ElIcon, ElSkeleton, ElSelect, ElOption, ElTag
} from 'element-plus';
import { ElLoading } from 'element-plus';
import 'element-plus/dist/index.css';
import moment from "moment";
import VueApexCharts from "vue3-apexcharts";
import { ArrowRight, CaretBottom, CaretTop, Warning } from '@element-plus/icons-vue';

let loading = null;

export default {
    name: "SalesDashboard",
    components: {
        VueApexCharts, ElRow, ElButton, ElDatePicker, ElCol, ElTableColumn,
        ElTable, ElStatistic, ElTooltip, ElIcon, Warning, ElSkeleton, ElSelect, ElOption, ElTag
    },
    data() {
        return {
            form: {
                type: 0,
                date: [
                    moment().startOf('month').format('YYYY-MM-DD'),
                    moment().format('YYYY-MM-DD')
                ],
            },
            user: null,
            reports: null,
            leadsstatusCO: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    },
                },
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: true
                },
                stroke: {
                    curve: 'straight',
                    width: 2
                },
                title: {
                    text: 'Leads Report',
                    align: 'left'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Leads'
                    },
                    min: 0
                },
                markers: {
                    size: 1
                },
            },
            chartOptions: {
                chart: {
                    height: 150,
                    type: 'radialBar',
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 225,
                        hollow: {
                            margin: 0,
                            size: '70%',
                            background: '#fff',
                            image: undefined,
                            imageOffsetX: 0,
                            imageOffsetY: 0,
                            position: 'front',
                            dropShadow: {
                                enabled: true,
                                top: 3,
                                left: 0,
                                blur: 4,
                                opacity: 0.5
                            }
                        },
                        track: {
                            background: '#fff',
                            strokeWidth: '67%',
                            margin: 0,
                            dropShadow: {
                                enabled: true,
                                top: -3,
                                left: 0,
                                blur: 4,
                                opacity: 0.7
                            }
                        },
                        dataLabels: {
                            show: true,
                            name: {
                                show: false,
                            },
                            value: {
                                formatter: function (val) {
                                    return parseInt(val) + "%";
                                },
                                show: true,
                                fontSize: '28px',
                                fontWeight: 'bold',
                                color: '#000',
                                offsetY: 10
                            }
                        }
                    },
                },
                colors: ['#e74c3c'],
            }
        };
    },
    mounted() {
        this.getdata();
    },
    methods: {
        getColor() {
            if (this.reports) {
                const perc = this.percentComplete();
                if (perc < 50) return ['#e74c3c']; // red
                if (perc < 90) return ['#f39c12']; // orange
                return ['#27ae60'];
            } else {
                return ['#e74c3c'];
            }
        },
        percentComplete() {
            if (!this.reports.profit || this.reports.target === 0) return 0;
            return ((this.reports.profit / this.reports.target) * 100).toFixed(1);
        },
        getPercentage(profit, target) {
            if (!target || target === 0) return 0;
            const percent = (profit / target) * 100;
            return percent.toFixed(0);
        },
        getdata() {
            loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let currentObj = this;
            currentObj.reports = null;
            axios.post('/dashboard/agetsalesdata', this.form).then(function (response) {
                currentObj.reports = response.data.report;
                currentObj.user = response.data.user;
                currentObj.leadsstatusCO.xaxis = response.data.report.graph.leads.xaxis;
                loading.close();
            }).catch(function (error) {
                loading.close();
            });
        }
    }
};
</script>

<style scoped>
:global(h2#card-usage ~ .example .example-showcase) {
    background-color: var(--el-fill-color) !important;
}

.el-statistic {
    --el-statistic-content-font-size: 28px;
}

.statistic-card {
    height: 100%;
    padding: 20px;
    border-radius: 4px;
    background-color: var(--el-bg-color-overlay);
}

.statistic-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-size: 12px;
    color: var(--el-text-color-regular);
    margin-top: 16px;
}

.statistic-footer .footer-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.statistic-footer .footer-item span:last-child {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
}

.green {
    color: var(--el-color-success);
}

.red {
    color: var(--el-color-error);
}
</style>